import AssetAllocationFunds from "./AssetAllocationFunds.jsx";

export default AssetAllocationFunds;



// WEBPACK FOOTER //
// ./src/components/pages/Create_portfolio_by_Advisor/asset_allocation_funds/index.js